import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgSearchDrawnGray = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32.0155 24.72C31.2127 31.8392 25.1944 37.0051 17.4989 36.1374C9.8035 35.2696 4.42421 30.8581 5.227 23.739C6.02979 16.6198 11.4498 8.93871 19.1452 9.80648C26.8407 10.6743 32.8183 17.6009 32.0155 24.72Z",
			fill: "#E2E2E4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.36027 18.532C7.76791 14.917 12.2626 6.39345 21.567 7.44266C30.8714 8.49187 33.3264 16.7417 33.1111 21.436C33.0016 23.8866 31.6681 27.3697 28.943 29.9282M7.36027 23.1707C7.03415 26.0627 10.9141 32.3565 18.3577 33.1959C23.0474 33.7248 26.5374 32.1867 28.943 29.9282M28.943 29.9282L31.4643 32.646M31.4643 32.646L34.114 30.5113C36.8975 33.1235 41.6375 37.849 41.1397 39.4151C40.5175 41.3729 39.2378 42.0397 38.4449 41.9503C37.8106 41.8788 32.2175 37.7331 29.1489 35.2239L31.4643 32.646Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7422 16.3223C16.7182 16.6849 16.2381 23.9369 16.1565 25.1696",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5117 18.375C12.5437 18.7177 12.3878 20.5902 12.3059 21.4836",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSearchDrawnGray;
